/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type Tmp2Value = "override";
export const Tmp2Context = React.createContext<Tmp2Value | undefined>(
  "PLEASE_RENDER_INSIDE_PROVIDER" as any
);
export function Tmp2ContextProvider(
  props: React.PropsWithChildren<{ value: Tmp2Value | undefined }>
) {
  return (
    <Tmp2Context.Provider value={props.value}>
      {props.children}
    </Tmp2Context.Provider>
  );
}

export function useTmp2() {
  return React.useContext(Tmp2Context);
}

export default Tmp2Context;
/* prettier-ignore-end */
